// @flow
import React, { Component } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import EstimateView from 'components/estimate/EstimateView/EstimateView';
import { type UserData } from 'store/modules/user';
import { EstimateActions } from 'store/actionCreators';
import { getEstimate, type UploadInfo } from 'store/modules/estimate';

type Props = {
  user: ?UserData,
  estimate: ?getEstimate,
  uploadInfo: ?UploadInfo,
};

class EstimateViewContainer extends Component<Props> {
  initialize = () => {
    const { user } = this.props;
    if (!user) return;
    EstimateActions.getEstimate(user.username);
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.initialize();
    }
  }

  render() {
    const { selectEstimateBox } = this.props;
    if (!selectEstimateBox) return null;
    return (
      <EstimateView
        estimate={selectEstimateBox}
        onUploadEstimate={this.onUploadEstimate}
        onRemoveEstimate={this.onRemoveEstimate}
        onViewEstimate={this.onViewEstimate}
      />
    );
  }
}

export default connect(
  ({ user, estimate }: State) => ({
    user: user.user,
    estimate: estimate.estimate,
    selectEstimateBox: estimate.selectEstimateBox,
    uploadInfo: estimate.uploadInfo,
  }),
  () => ({}),
)(EstimateViewContainer);



// WEBPACK FOOTER //
// ./src/containers/estimate/EstimateViewContainer.js